import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { getEmpFullNameTHByEmpData, getSupplierFullName, pageSizeOptions } from "utils/HelperFunction";
import moment from "moment";
import { NumericFormat } from "react-number-format";
import { usePesInitContext } from "contexts/purhaseExpenseSyncPage/pesInitContext";
import { Button } from "react-bootstrap";
export function PesMultiSelectTable() {
    var pesInitContext = usePesInitContext();
    var grReviewListState = pesInitContext.grReviewListState, expListState = pesInitContext.expListState, isInitPesLoading = pesInitContext.isInitPesLoading, options = pesInitContext.options, docSelected = pesInitContext.docSelected, setDocSelected = pesInitContext.setDocSelected, docSeletecteds = pesInitContext.docSeletecteds, setDocSeletecteds = pesInitContext.setDocSeletecteds, handleRowSelectOverridePesModal = pesInitContext.handleRowSelectOverridePesModal, docOptions = pesInitContext.docOptions, setDocOptions = pesInitContext.setDocOptions, totalSelectedCount = pesInitContext.totalSelectedCount, productRow = pesInitContext.productRow, setProductRow = pesInitContext.setProductRow, handleConfirmSelect = pesInitContext.handleConfirmSelect;
    var columnsd = [
        {
            field: "doc_number",
            headerName: "เลขที่เอกสาร",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(Link, {
                    to: "/financial-accounting/creditor/goods-receipt/".concat(row.id),
                    className: "text-[#565DFF] font-semibold underline",
                    children: row.doc_number
                });
            }
        },
        {
            field: "refer",
            headerName: "เลขที่อ้างอิง",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    className: "tc-8",
                    children: row.refer
                });
            }
        },
        {
            field: "dimSupplierInformation",
            headerName: "ผู้จัดจำหน่าย",
            width: 250,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.dimSupplierInformation ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            getSupplierFullName(row.dimSupplierInformation),
                            row.dimSupplierInformation.company_branch_name && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("br", {}),
                                    "(",
                                    row.dimSupplierInformation.company_branch_name || "-",
                                    ")"
                                ]
                            })
                        ]
                    }) : "-"
                });
            }
        },
        {
            field: "financialLastUpdateByEmp",
            headerName: "ผู้ตรวจสอบ",
            width: 250,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.financialLastUpdateByEmp ? /*#__PURE__*/ _jsx(_Fragment, {
                        children: getEmpFullNameTHByEmpData(row.financialLastUpdateByEmp)
                    }) : "-"
                });
            }
        },
        {
            field: "financial_last_updated_at",
            headerName: "วันที่ตรวจสอบ",
            width: 150,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    className: "tc-8",
                    children: row.financial_last_updated_at ? moment.utc(row.financial_last_updated_at).add(7, "hours").format("DD/MM/YYYY HH:mm:ss") : "-"
                });
            }
        },
        {
            field: "total_price_before_vat",
            headerName: "มูลค่าก่อนภาษี",
            sortable: false,
            width: 160,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(NumericFormat, {
                    className: "tc-4",
                    displayType: "text",
                    thousandSeparator: ",",
                    decimalScale: 2,
                    fixedDecimalScale: true,
                    value: row.total_price_before_vat
                });
            }
        },
        {
            field: "total_price_vat",
            headerName: "ภาษีมูลค่าเพิ่ม",
            sortable: false,
            width: 160,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(NumericFormat, {
                    className: "tc-4",
                    displayType: "text",
                    thousandSeparator: ",",
                    decimalScale: 2,
                    fixedDecimalScale: true,
                    value: row.total_price_vat
                });
            }
        },
        {
            field: "grand_total_price",
            headerName: "มูลค่าสุทธิ",
            sortable: false,
            width: 160,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(NumericFormat, {
                    className: "tc-4",
                    displayType: "text",
                    thousandSeparator: ",",
                    decimalScale: 2,
                    fixedDecimalScale: true,
                    value: row.grand_total_price
                });
            }
        }
    ];
    var isGlobalLoading = useMemo(function() {
        return [
            isInitPesLoading,
            grReviewListState.isInitGrLoading,
            expListState.isInitExpLoading
        ].some(Boolean);
    }, [
        isInitPesLoading,
        grReviewListState.isInitGrLoading,
        expListState.isInitExpLoading
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "pagezoom",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex justify-between",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "min-w-[200px]",
                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "form-st-3 sm pb-1",
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Label, {
                                        className: "mb-1",
                                        children: "เลือกเอกสาร"
                                    }),
                                    /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        name: "",
                                        onChange: function(e) {
                                            setDocSelected(e.value);
                                        },
                                        className: "w-full select-st-1 pd",
                                        options: docOptions,
                                        placeholder: "",
                                        value: docOptions.filter(function(item) {
                                            return item.value === docSelected;
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex gap-[10px]",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    onClick: function(e) {
                                        handleConfirmSelect(pesInitContext);
                                    },
                                    className: "btn-st-3  h-[38px]",
                                    children: "ยืนยันที่เลือก"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "fs-14 tc-5 w-[151px] h-[38px] flex justify-center items-center bg-[#F4F4F4] rounded-[8px] shadow-md",
                                    children: [
                                        "เลือกไว้ ",
                                        totalSelectedCount,
                                        " รายการ"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2 pagezoom",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "card-body px-0 pt-4 pb-0",
                    children: docOptions && docOptions.map(function(docOp) {
                        var keySelected = docOp.keySelected;
                        var stateNameData = pesInitContext[keySelected];
                        if (docSelected !== docOp.value || !stateNameData) return null;
                        return /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "d-flex align-items-center px-4 mb-3 flex-wrap",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-2 me-auto",
                                            style: {
                                                width: "220px"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "form-st-3 sm pb-1",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1",
                                                        children: "กลุ่มผู้จัดจำหน่าย"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Select, {
                                                        as: "select",
                                                        name: "",
                                                        onChange: function(e) {
                                                            stateNameData.setSelectedGroupOfSuplierID(e.value);
                                                        },
                                                        className: "w-100 select-st-1 pd",
                                                        options: options.groupOfSupplier,
                                                        placeholder: "",
                                                        value: options.groupOfSupplier.filter(function(item) {
                                                            return item.value === stateNameData.selectedGroupOfSuplierID;
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "me-3 mb-2",
                                            children: /*#__PURE__*/ _jsx("input", {
                                                type: "text",
                                                className: "form-control form-st-4",
                                                placeholder: "ค้นหาเลขที่,ชื่อผู้จำหน่าย",
                                                onChange: function(e) {
                                                    return stateNameData.setFilterText(e.target.value);
                                                },
                                                value: stateNameData.filterText
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    sx: {
                                        width: "100%",
                                        height: "800px"
                                    },
                                    children: /*#__PURE__*/ _jsx(DataGrid, {
                                        getRowId: function(row) {
                                            return row.id;
                                        },
                                        getRowHeight: function() {
                                            return "auto";
                                        },
                                        loading: isGlobalLoading,
                                        rows: stateNameData.data,
                                        pagination: true,
                                        paginationMode: "server",
                                        paginationModel: {
                                            page: stateNameData.pageModel.page - 1,
                                            pageSize: stateNameData.pageModel.pageSize
                                        },
                                        onPaginationModelChange: function(newPagination) {
                                            stateNameData.setPageModel(function(prev) {
                                                return _object_spread_props(_object_spread({}, prev), {
                                                    page: newPagination.page + 1,
                                                    pageSize: newPagination.pageSize
                                                });
                                            });
                                            stateNameData.getData(newPagination.page + 1, newPagination.pageSize, stateNameData.filterText || "", stateNameData.selectedGroupOfSuplierID, stateNameData.btnempstatus || "");
                                        },
                                        rowsPerPage: stateNameData.pageModel.page,
                                        rowCount: stateNameData.pageModel.total,
                                        columns: columnsd,
                                        pageSizeOptions: pageSizeOptions,
                                        checkboxSelection: true,
                                        disableRowSelectionOnClick: true,
                                        slotProps: {
                                            pagination: {
                                                labelRowsPerPage: "จำนวนรายการต่อหน้า"
                                            }
                                        },
                                        sx: {
                                            fontFamily: "Sarabun",
                                            fontSize: "16px",
                                            ".MuiDataGrid-columnHeaderTitle": {
                                                fontFamily: "Sarabun",
                                                fontSize: "16px"
                                            },
                                            "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-checkboxInput": {
                                                display: "none"
                                            }
                                        },
                                        onRowSelectionModelChange: function(ids) {
                                            handleRowSelectOverridePesModal({
                                                ids: ids,
                                                keySelected: keySelected
                                            });
                                        },
                                        rowSelectionModel: docSeletecteds[keySelected] || []
                                    })
                                })
                            ]
                        }, keySelected);
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "py-4"
            })
        ]
    });
}
